import { observer } from 'mobx-react-lite';
import * as React from 'react';
import Favorites from './Favorites';
import { getMailAccountSources } from 'owa-account-source-list-store';
import { isFavoritesNoReflowEnabled } from 'owa-favorites';

export interface FavoritesTreeProps extends React.HTMLProps<HTMLDivElement> {
    setSize: number;
    positionInSet: number;
}

const FavoritesTree = observer(function FavoritesTree(props: FavoritesTreeProps) {
    if (isFavoritesNoReflowEnabled()) {
        const accountSources = getMailAccountSources();
        return (
            <div>
                {accountSources.map(accountSource => (
                    <Favorites
                        key={accountSource.sourceId}
                        accountSource={accountSource}
                        {...props}
                    />
                ))}
            </div>
        );
    } else {
        return <Favorites {...props} />;
    }
});

export default FavoritesTree;
